import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatDrawerMode } from '@angular/material/sidenav';
import { DomSanitizer } from '@angular/platform-browser';
import { BreakpointObserverService } from '@visiativ/digital-components-kit';
import { OAuthService } from 'angular-oauth2-oidc';
import { Subject, takeUntil } from 'rxjs';
import { SidenavComponent } from './components/sidenav/sidenav.component';

@Component({
	selector: 'app-portal',
	templateUrl: './portal.component.html',
	styleUrls: ['./portal.component.scss'],
	standalone: true,
	imports: [SidenavComponent],
})
export class PortalComponent implements OnDestroy, OnInit {
	public customIcons: string[] = [];
	public isNavbarOpenedValue = true;
	public sidenavMode: MatDrawerMode = 'side';
	public sidenavSize: string | undefined;
	private readonly unsubscribeSubject = new Subject<void>();
	private readonly domSanitizer = inject(DomSanitizer);
	private readonly matIconRegistry = inject(MatIconRegistry);
	public readonly oauthService = inject(OAuthService);
	public readonly breakpointObserverService = inject(BreakpointObserverService);

	ngOnInit(): void {
		this.customIcons.push('edit_square_outline');
		this.customIcons.forEach(icon => {
			this.matIconRegistry.addSvgIcon(
				icon,
				this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${icon}.svg`),
			);
		});
		this.configureScreenSizeSubject();
	}

	ngOnDestroy(): void {
		this.unsubscribeSubject.next();
		this.unsubscribeSubject.complete();
	}

	private configureScreenSizeSubject(): void {
		this.breakpointObserverService.screenSizeSubject
			.pipe(takeUntil(this.unsubscribeSubject))
			.subscribe(value => {
				this.isNavbarOpenedValue =
					(value === 'Large' || value === 'XLarge') &&
					this.oauthService.hasValidAccessToken() &&
					this.oauthService.hasValidIdToken();
				this.sidenavSize = value === 'Large' || value === 'XLarge' ? '290px' : '240px';
				this.sidenavMode = value === 'Large' || value === 'XLarge' ? 'side' : 'push';
			});
	}
}
